// extracted by mini-css-extract-plugin
module.exports = {"actions":"ShareListModal_actions__g_vmn","modal":"ShareListModal_modal__3Q1Lf"};